import { type CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import type {
	SelectFilterMonad,
	SelectFilterState,
} from '../../../../../common/constants/filters/select-filter/types';
import { getSiteCloudId } from '../../../../../common/constants/filters/site';
import {
	all1pProductKeys,
	all3pProductKeys,
	type ProductKeys,
} from '../../../../../common/constants/product-keys';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

export const filter: Readonly<{
	id: 'site';
	type: 'single-select' | 'multi-select';
	queryParams: {
		key: string;
		getState: (queryParams: Record<string, string[]>, cloudId: string) => SelectFilterState<'site'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (state: unknown, config: CloudConfig) => SelectFilterMonad<'site'>;
	getInitialState: (config: CloudConfig) => SelectFilterMonad<'site'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createMultiSelectFilter({
	id: 'site',
	products: [...all1pProductKeys, ...all3pProductKeys],
	alwaysVisible: false,
	universal: true,
	queryParams: {
		key: 'sites',
		fetcher: async (queryParams, config) => {
			return (config.unitMetadata ?? [])
				.map((site) => ({ cloudId: getSiteCloudId(site.id), siteName: site.siteName }))
				.filter(
					({ cloudId }) =>
						cloudId !== config.cloudId && // Excludes the current site (injected as display-only)
						queryParams.includes(cloudId),
				)
				.map(({ cloudId, siteName }) => ({
					trackingKey: cloudId,
					value: cloudId,
					label: siteName,
					queryParamValue: cloudId,
					isSelected: true,
				}));
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			return (config.unitMetadata ?? [])
				.map((site) => ({ cloudId: getSiteCloudId(site.id), siteName: site.siteName }))
				.filter(
					({ cloudId }) => cloudId !== config.cloudId, // Excludes the current site (injected as display-only)
				)
				.map(({ cloudId, siteName }) => ({
					trackingKey: cloudId,
					value: cloudId,
					label: siteName,
					queryParamValue: cloudId,
				}));
		},
	},
});
